import React, { FC } from "react"
import { Link, useLocation } from "react-router-dom"
import { getLocationName } from "../../helpers"

const Breadcrumbs: FC = () => {
  const locationName: string = useLocation().pathname;

  return (
    <ul className='breadcrumbs-new'>
      <li><Link to='/'>Проектировщикам</Link></li>
      <li><Link to={locationName}>{getLocationName(locationName)}</Link></li>
    </ul>
  )
}

export default Breadcrumbs;
